export const CORE_SECTOR = 10;
export const TOTAL_SECTORS = CORE_SECTOR;
export const REGULAR_SECTORS = CORE_SECTOR - 1;

// All tile effects, including relaunches, must identify the same saved round.
export const getBoardEncounterRound = (game) =>
  game.guardian?.active
    ? 'guardian:' + game.guardian.round
    : game.floor === CORE_SECTOR
    ? game.bossRound
    : game.miniBoss?.active
    ? 'warden:' + game.miniBoss.round
    : null;
